export default {
  tournament: null,
  results: [],
  matches: []
}
